import { type QueryHookOptions, QueryResult } from "@apollo/client/react/types/types";
import { FIND_LEAVE_PLANS_QUERY } from "../Queries";
import { useQuery } from "@apollo/client";
import { LeavePlan } from "../generated/graphql";
import { BenefitType, findDefaultLeaveTypesFor } from "../component/enums/BenefitType";
import { ClaimPlan } from "../component/domain/ClaimPlan";
import { getValueByKey } from "../component/enums/KeyFinder";
import { LeaveType } from "../component/enums/LeaveType";
import { Relationship } from "../component/enums/Relationship";
import { Medical } from "../component/enums/Medical";
import {AuthContextProps} from "oidc-react";

export function useLeavePlans(policyId?: string, workState?: string, effectiveDate?: string | null, auth?: AuthContextProps, options?: QueryHookOptions): QueryResult<{ findLeavePlans: ClaimPlan[] }> {
    const user = auth?.userData;
    const signedIn = !!user;
    const skip = !signedIn || policyId?.length !== 7 || !workState;
    const queryResult = useQuery(FIND_LEAVE_PLANS_QUERY, {
        variables: {
            policyId,
            workState,
            effectiveDate
        },
        skip: skip,
        ...options
    });

    if(skip || queryResult.loading || queryResult.error) {
        return {
            ...queryResult,
            data: {
                findLeavePlans: findDefaultLeaveTypesFor(BenefitType.PAID_FAMILY_AND_MEDICAL_LEAVE)
            }
        }
    }
    const leavePlans = queryResult?.data?.findLeavePlans?.map((leavePlan: LeavePlan) => ({
        leaveType: getValueByKey(LeaveType, leavePlan.type),
        relationship: leavePlan.relationship.map(relationship => getValueByKey(Relationship, relationship)),
        medical: leavePlan.medical.map(medical => getValueByKey(Medical, medical))
    }));
    return {
        ...queryResult,
        data: {
            findLeavePlans:  leavePlans?.length ? leavePlans : findDefaultLeaveTypesFor(BenefitType.PAID_FAMILY_AND_MEDICAL_LEAVE)
        }
    };
}
